// src/app/pipes/options-of-type.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'optionsOfType',
    standalone: false
})
export class OptionsOfTypePipe implements PipeTransform {
  transform(options: any[], type: string): any[] {
    return options.filter(option => option.type === type);
  }
}